module.exports = __webpack_public_path__ + "static/media/industry-cancer.76de68b5.jpg";